import React from "react";
import DataTable from "react-data-table-component";
import dayjs from "dayjs";

function ProjectListTable({ isModal, setIsModal, setProjectId, setIsDeleteModal, setIsViewModal, data, deletePermission, editPermission, viewPermission, listPermission }) {

    let columnT = ""

    columnT = [
        {
            name: "PROJECT NAME",
            selector: (row) => row.projectName,
            sortable: true,
            cell: (row) => <b>{row.projectName}</b> 
        },
        {
            name: "CATEGORY",
            selector: (row) => row.projectCategory,
            sortable: true
        },
        {
            name: "ASSIGN PERSON",
            selector: (row) => row.assigned,
            sortable: true,
            cell: row => <div><span className="fw-bold ms-1">{row.assignPerson?.employeeName}</span></div>,
        },

        {
            name: "START DATE",
            selector: (row) => dayjs(row.projectStartDate).format("DD-MM-YYYY"),
            sortable: true
        },
        {
            name: "END DATE",
            selector: (row) => dayjs(row.projectEndDate).format("DD-MM-YYYY"),
            sortable: true
        },
        {
            name: "STATUS",
            selector: (row) => { },
            sortable: true,
            cell: row => <span className={`badge ${row.projectStatus === "Completed" ? 'bg-success' : row.projectStatus === "Open" ? "bg-primary" : "bg-warning"}`}>{row.projectStatus}</span>

        },
        {
            name: "ACTION",
            selector: (row) => { },
            sortable: true,
            minWidth: "150px",
            cell: (row) => (<div className="btn-group" role="group" aria-label="Basic outlined example">
                {(viewPermission === 1) && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsViewModal(true); setProjectId(row?._id) }} ><i className="icofont-eye-alt text-primary"></i></button>)}
                {(editPermission === 1) && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsModal(true); setProjectId(row?._id); }}><i className="icofont-edit text-success"></i></button>)}
                {(deletePermission === 1) && (<button type="button" className="btn btn-outline-secondary deleterow" onClick={() => { setIsDeleteModal(true); setProjectId(row?._id) }} ><i className="icofont-ui-delete text-danger"></i></button>)}
            </div>)
        }

    ]

    return (
        <div className="container-xxl">
            <div className="row clearfix g-3">
                <div className="col-md-12"> 
                    {listPermission === 1 && (
                        <div className="card">
                            <div className="card-body">
                                <DataTable
                                    title={"Project List"}
                                    columns={columnT}
                                    data={data?.data}
                                    defaultSortField="title"
                                    pagination
                                    selectableRows={false} 
                                    className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                    highlightOnHover={true}
                                />
                            </div>
                        </div>
                    )}                    
                </div>
            </div>
        </div>
    )

}

export default ProjectListTable;